<template>
  <div class="chart">
    <div class="chart_wrap" v-loading="loading">
      <curr-line-chart :data="item"></curr-line-chart>
    </div>

    <div class="chart_wrap" v-loading="loading">
      <after-line-chart :data="item"></after-line-chart>
    </div>

    <div class="chart_wrap" v-if="item.loopNum == 12" v-loading="loading"><!-- 能耗版设备 -->
      <volt-line-chart :data="item"></volt-line-chart>
    </div>

    <div class="chart_wrap" v-loading="loading">
      <temp-line-chart :data="item"></temp-line-chart>
    </div>

    <div class="chart_wrap" v-if="item.loopNum == 12" v-loading="loading"><!-- 能耗版设备电度 -->
      <eledeg-line-chart :data="item"></eledeg-line-chart>
    </div>

    <div class="chart_wrap" v-if="item.loopNum == 12" v-loading="loading"><!-- 能耗版设备有功功率 -->
      <actpow-line-chart :data="item"></actpow-line-chart>
    </div>
  </div>
</template>

<script>
  import currLineChart from '@/components/echarts/CurrLineChart'
  import afterLineChart from '@/components/echarts/AfterLineChart'
  import voltLineChart from '@/components/echarts/VoltLineChart'
  import tempLineChart from '@/components/echarts/TempLineChart'
  import eledegLineChart from '@/components/echarts/EledegLineChart'
  import actpowLineChart from '@/components/echarts/ActpowLineChart'

  export default {
    props: ['item'],
    components: {
      currLineChart,
      afterLineChart,
      voltLineChart,
      tempLineChart,
      eledegLineChart,
      actpowLineChart
    },
    computed: {
      loading() {
        return this.$store.state.loading;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .chart_wrap {
    display: flex;
    width: 100%;
    height: 420px;
    flex-wrap: wrap;
    margin: 30px 1% 0 1%;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 0px;
    box-sizing: border-box;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/component/base-device-chart.vue